import { Component, output, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface DateRange {
  from: { year: number; month: number; day: number } | null;
  to: { year: number; month: number; day: number } | null;
}

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class RangeDatePickerComponent {
  // Output event
  selectedDates = output<DateRange>();

  // Signals for date values
  fromDate = signal<string>('');
  toDate = signal<string>('');

  // Computed date range
  dateRange = computed<DateRange>(() => ({
    from: this.fromDate() ? this.parseDate(this.fromDate()) : null,
    to: this.toDate() ? this.parseDate(this.toDate()) : null,
  }));

  onFromDateChange(value: string): void {
    this.fromDate.set(value);
    this.emitDates();
  }

  onToDateChange(value: string): void {
    this.toDate.set(value);
    this.emitDates();
  }

  private emitDates(): void {
    this.selectedDates.emit(this.dateRange());
  }

  private parseDate(dateString: string): { year: number; month: number; day: number } | null {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    return { year, month, day };
  }
}
